import { cn } from '@/lib/utils'

type SpinnerSize = 'sm' | 'md' | 'lg'

interface SpinnerProps {
  size?: SpinnerSize
  className?: string
}

interface LoadingStateProps {
  label?: string
  size?: SpinnerSize
  fullscreen?: boolean
  className?: string
  textClassName?: string
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-[3px]',
  lg: 'h-10 w-10 border-[3px]',
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-block animate-spin rounded-full border-current border-t-transparent',
        sizeClasses[size],
        className,
      )}
    />
  )
}

export function LoadingState({
  label = 'Loading...',
  size = 'md',
  fullscreen = false,
  className,
  textClassName,
}: LoadingStateProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center',
        fullscreen && 'min-h-screen w-full',
        className,
      )}
    >
      <div className="text-center">
        <Spinner size={size} className="mx-auto mb-4 text-primary/80" />
        <p className={cn('text-sm text-muted-foreground', textClassName)}>{label}</p>
      </div>
    </div>
  )
}